import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms'
import { TypedFormGroup } from '@feature/forms/form-model';;
import { UntilDestroy } from '@ngneat/until-destroy';
import { QuillModules } from 'ngx-quill';
import { TranslateService } from '@ngx-translate/core';

// Register color attributors globally
import Quill from 'quill';
const ColorStyle = Quill.import('attributors/style/color');
const BackgroundStyle = Quill.import('attributors/style/background');
Quill.register(ColorStyle, true);
Quill.register(BackgroundStyle, true);



const defaultModules: QuillModules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
};

@UntilDestroy()
@Component({
    selector: 'wai-form-rich-text',
    templateUrl: './form-rich-text.component.html',
    styleUrls: ['./form-rich-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormRichTextComponent implements OnInit {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @Input() public modules: QuillModules = defaultModules;
  @Input() public control: FormControl;
  @Input() public label: string;
  @Input() public placeholder = this.translate.instant('INTL_PLACEHOLDER_DEFAULT');
  @Input() public isDisabled: boolean;

  constructor(private cdRef: ChangeDetectorRef, private translate: TranslateService) {}

  public ngOnInit(): void {
    if (this.isDisabled) {
      this.control.disable();
    }
  }

  public onEditorCreated(): void {
    this.detectChanges();
  }

  public detectChanges(): void {
    this.cdRef.detectChanges();
  }

  public isRequired(): boolean {
    const validator = this.control?.validator ? this.control.validator({} as AbstractControl) : null;
    return validator && validator.required;
  }
}
